import { graphql } from "~/lib/graphql";

export const CtaButtonFragment = graphql(`
  fragment CtaButtonFragment on CtaButtonRecord {
    __typename
    id
    internalUrl
    externalUrl
    label
  }
`);
